import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import InternalTransactionDetails from "../../../containers/InternalTransactionMain/InternalTransactionDetails";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";

function InternalTxnDetailPagePopup({
  closeInternalTxnDetailModal,
  internal_txn_id,
  type,
  error_msg,
  setShowInternalTxnDetailPop,
  setErrorMessage,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
      setShowInternalTxnDetailPop(false);
      setErrorMessage("");
    };
  }, []);

  return (
    <div>
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-width-full h-height-full"
      >
        <LargePopupRedirect
          headerTitle="Internal Transaction Details"
          headersubtext=""
          isfullViewrequired={true}
          fullviewisDisabled={false}
          fullviewhoverOption="white"
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewdisabledBgColor="var(--text-disabled)"
          fullviewicon={ICONS?.REDIRECT}
          fullviewhandleFunction={() => {
            closeInternalTxnDetailModal();

            navigate(
              `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${internal_txn_id}`,
            );
          }}
          closeiconhandleFunction={closeInternalTxnDetailModal}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
        >
          <InternalTransactionDetails
            internal_txn_id={internal_txn_id}
            closeInternalTxnDetailModal={closeInternalTxnDetailModal}
            type={type}
            error_msg={error_msg}
          />
        </LargePopupRedirect>
      </div>
    </div>
  );
}

export default InternalTxnDetailPagePopup;
